import React, { useState } from 'react';
import "./App.css";
import { useNavigate, Link } from 'react-router-dom';
import logoECJ from "./img/ecj-logo.svg";
import logoSvant from "./img/svant-logo.svg";
import { BACKEND_URL } from "./config";

function App() {
  const getStoredValue = (key, defaultValue = '') => {
    return sessionStorage.getItem(key) || defaultValue;
  };

  const setStoredValue = (key, value) => {
    sessionStorage.setItem(key, value);
  };

  const [airTravel, setAirTravel] = useState(getStoredValue('air_travel'));
  const [travelTime, setTravelTime] = useState(getStoredValue('travel_time'));
  const [eventTransport, setEventTransport] = useState(getStoredValue('event_transport'));
  const [kmLand, setKmLand] = useState(getStoredValue('km_land'));
  const [stayedInHotelFlag, setStayedInHotelFlag] = useState(getStoredValue('stayed_in_hotel'));
  const [hotelNights, setHotelNights] = useState(getStoredValue('hotel_nights'));
  const isHotelYes = stayedInHotelFlag === "1";
  const [questionsEmissions1, setQuestionsEmissions1] = useState(getStoredValue('questions_emissions_1'));
  const [questionsEmissions2, setQuestionsEmissions2] = useState(getStoredValue('questions_emissions_2'));
  const [questionsEmissions3, setQuestionsEmissions3] = useState(getStoredValue('questions_emissions_3'));
  const [formErrors, setFormErrors] = useState({});
  const requiresScope = questionsEmissions1 === "Sí" || questionsEmissions1 === "En proceso";
  const [submitting, setSubmitting] = useState(false); 
  const [submitError, setSubmitError] = useState("");  

  const navigate = useNavigate();
  const btnBack = () => {
    navigate('/'); 
  };

const collectPayload = () => {
  const pick = (k, def = "") => sessionStorage.getItem(k) || def;
  const toNum = (v) => {
    const n = Number(v);
    return Number.isFinite(n) ? n : 0;
  };

  const hotelFlag = toNum(pick("stayed_in_hotel"));
  const nights    = toNum(pick("hotel_nights"));

  return {
    first_name: pick("first_name"),
    last_name: pick("last_name"),
    dni: pick("dni"),
    email: pick("email"),
    phone: pick("phone"),
    position: pick("position"),
    region: pick("region"),
    sector: pick("sector"),
    employees: pick("employees"),
    id_company: pick("id_company") ? parseInt(pick("id_company"), 10) : null,
    company_name: pick("company_name") || null,
    invitation_code: (pick("invitation_code") || "").toUpperCase() || null,

    air_travel: pick("air_travel"),
    travel_time: toNum(pick("travel_time")),
    event_transport: pick("event_transport"),
    km_land: toNum(pick("km_land")),

    stayed_in_hotel: hotelFlag,
    hotel_nights: hotelFlag ? nights : 0,

    extra_answers: {
      questions_emissions_1: pick("questions_emissions_1"),
      questions_emissions_2: pick("questions_emissions_2"),
      questions_emissions_3: pick("questions_emissions_3"),
      questions_ECJ_1: pick("questions_ECJ_1"),
      questions_ECJ_2: pick("questions_ECJ_2"),
      questions_ECJ_3: pick("questions_ECJ_3"),
      questions_ECJ_4: pick("questions_ECJ_4"),
    },
  };
};


const btnNext = async (e) => { 
  e.preventDefault();
  setSubmitError("");

  const errores = {};
  if (!airTravel) errores.airTravel = 'Debe seleccionar una opción de vuelo';
  if (airTravel === "1" && !travelTime) errores.travelTime = 'Debe seleccionar una cantidad de horas';
  if (!eventTransport) errores.eventTransport = 'Debe seleccionar un tipo de transporte';
  if (!kmLand) errores.kmLand = 'Debe seleccionar una cantidad de km';
  if (!stayedInHotelFlag) errores.stayedInHotelFlag = 'Debe seleccionar una opción de hotel';
  if (stayedInHotelFlag === "1" && !hotelNights) errores.hotelNights = 'Debe seleccionar una cantidad de noches';

  setFormErrors(errores);
  if (Object.keys(errores).length > 0) return;

  try {
    setSubmitting(true);
    const payload = collectPayload();

    const res = await fetch(`${BACKEND_URL}/responses`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!res.ok) throw new Error("server_error");
    const data = await res.json();

    if (typeof data?.co2_total_per_user === "number") {
      localStorage.setItem("emissions_kg_co2e", String(data.co2_total_per_user));
    }
    if (data && data.user_id) {
      localStorage.setItem("user_id", String(data.user_id));
    }

    if (data?.status === "error") {
      setSubmitError(data?.message || "No pudimos procesar tu inscripción.");
      return;
    }

    if (data?.status === "ok" && data?.user_id && data?.is_invited) {
      try {
        await fetch(`${BACKEND_URL}/confirm-invited`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id_user_response: data.user_id }),
        });
      } catch (_) {}
      navigate("/thanks");
      return;
    }

    if (data?.status === "ok" && data?.user_id) {
      const AMOUNT_CENTS = 18500000; 
      const sp = await fetch(`${BACKEND_URL}/start-payment`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: sessionStorage.getItem("email"),
          amount: AMOUNT_CENTS,
          id_user_response: data.user_id,
        }),
      });
      const spData = await sp.json();
      const mpUrl = spData.payment_url || spData.init_point || spData.preference_url;
      if (mpUrl) {
        window.location.href = mpUrl;
        return;
      }
      setSubmitError("No se pudo iniciar el pago. Probá nuevamente.");
      return;
    }

    setSubmitError("No pudimos procesar tu inscripción.");
  } catch (err) {
    console.error(err);
    setSubmitError("Ocurrió un error enviando tu inscripción. Probá nuevamente.");
  } finally {
    setSubmitting(false);
  }
};

  const eventTransports = ["Auto", "Auto compartido", "Camioneta", "Camioneta compartida", "Colectivo", "Subte", "Ferry", "Bicicleta", "Caminando"];

  return (
    <div className='container'>
      <div className='flexBetween'>
        <img
          className='logoECJ'
          src={logoECJ}
          alt="EconoJournal"
        />
        <img
          className='logoSvant'
          src={logoSvant}
          alt="Svant Measure and Act"
        />
      </div>
      <h2>Formulario de emisiones</h2>
      <h4>Esta información será utilizada para calcular las emisiones de Gases de Efecto Invernadero del evento y generar un reporte.</h4>
      <form onSubmit={btnNext}>
        <div className='containerFlex'>
          <div className='col-2'>
            <label>¿Llegaste en avión a CABA? <b>*</b></label>
            <select
              value={airTravel}
              onChange={(e) => {
                const v = e.target.value;
                setAirTravel(v);
                setStoredValue('air_travel', v);
                if (v === "0") { 
                  setTravelTime("0");
                  setStoredValue('travel_time', "0");
                } else {
                  setTravelTime("");
                  setStoredValue('travel_time', "");
                }
              }}
            >
              <option value="" disabled>Seleccioná una opción</option>
              <option value="1">Sí</option>
              <option value="0">No</option>
            </select>
            {formErrors.airTravel && <span className="required">{formErrors.airTravel}</span>}
          </div>

          <div className='col-2'>
            <label>¿Cuántas horas volaste? <b>*</b></label>
            <select
              value={airTravel !== "0" ? travelTime : null}
              name="travel_time"
              onChange={(e) => {
                setTravelTime(e.target.value);
                setStoredValue('travel_time', e.target.value);
              }}
              disabled={airTravel !== "1"}
              required={airTravel === "1"}
            >
              <option value="" disabled>
              {airTravel === "1" ? "Seleccioná una cantidad de hs" : "No corresponde"}
            </option>
              {["0.5","1","1.5","2","2.5","3","3.5","4","4.5","5","5.5","6","6.5","7","7.5","8","8.5","9","9.5","10"]
                .map(h => <option key={h} value={h}>{h} horas</option>)}
            </select>

            {formErrors.travelTime && <span className="required">{formErrors.travelTime}</span>}
          </div>
        </div>

        <div className='containerFlex'>
          <div className='col-2'>
            <label>¿En qué transporte vas a llegar al evento? <b>*</b></label>
            <select value={eventTransport} name='transport' onChange={(e) => { setEventTransport(e.target.value); setStoredValue('event_transport', e.target.value) }} required>
            <option value="" disabled>Seleccioná un medio de transporte</option>
            {eventTransports.map((mode) => (
              <option key={mode} value={mode}>{mode}</option>
            ))}
          </select>
          {formErrors.eventTransport && <span className="required">{formErrors.eventTransport}</span>}
          </div>

          <div className='col-2'>
          <label>Aproximadamente ¿Cuántos km vas a recorrer para llegar al evento? <b>*</b></label>
          <select
            value={kmLand}
            name="km_land"
            onChange={(e) => {
              const v = e.target.value;
              setKmLand(v);
              setStoredValue('km_land', v);
            }}
            required
          >
            <option value="" disabled>Seleccioná una cantidad de kms</option>
            <option value="3">Entre 0 y 5 KM</option>
            <option value="8">Entre 5 y 10 KM</option>
            <option value="15">Entre 10 y 20 KM</option>
            <option value="25">Entre 20 y 30 KM</option>
            <option value="35">Entre 30 y 40 KM</option>
            <option value="45">Entre 40 y 50 KM</option>
            <option value="75">Entre 50 y 100 KM</option>
            <option value="150">Entre 100 y 200 KM</option>
            <option value="300">Entre 200 y 400 KM</option>
            <option value="500">Más de 400</option>
          </select>
          {formErrors.kmLand && <span className="required">{formErrors.kmLand}</span>}
        </div>

        </div>

        <div className='containerFlex'>
        <div className='col-2'>
          <label>¿Te hospedás en un hotel durante tu estadía en CABA? <b>*</b></label>
          <select
            value={stayedInHotelFlag}
            onChange={(e) => {
              const v = e.target.value; 
              setStayedInHotelFlag(v);
              setStoredValue('stayed_in_hotel', v);
              if (v === "0") {
                setHotelNights("0");
                setStoredValue('hotel_nights', "0");
              } else {
                setHotelNights("");
                setStoredValue('hotel_nights', "");
              }
            }}
          >
            <option value="" disabled>Seleccioná una opción</option>
            <option value="1">Sí</option>
            <option value="0">No</option>
          </select>
          {formErrors.stayedInHotelFlag && <span className="required">{formErrors.stayedInHotelFlag}</span>}
        </div>

        <div className='col-2'>
          <label>¿Cuántas noches te hospedás? <b>*</b></label>
          <select
            value={stayedInHotelFlag !== "0" ? hotelNights : null}
            name="hotel_nights"
            onChange={(e) => {
              const v = e.target.value;
              setHotelNights(v);
              setStoredValue('hotel_nights', v);
            }}
            disabled={!isHotelYes}
            required={isHotelYes}
          >
            <option value="" disabled>
              {isHotelYes ? "Seleccione una cantidad de noches" : "No corresponde"}
            </option>
            {[1,2,3,4].map(d => (
              <option key={d} value={String(d)}>
                {d} {d === 1 ? "noche" : "noches"}
              </option>
            ))}
          </select>
          {formErrors.hotelNights && <span className="required">{formErrors.hotelNights}</span>}
        </div>
      </div>


        <div className='containerFlex'>
          <div className='col-2'>
            <label>¿Tu empresa mide actualmente sus emisiones de Gases de Efecto Invernadero? <b>*</b></label>
            <select
              value={questionsEmissions1}
              name='questions_emissions_1'
             onChange={(e) => {
                const v = e.target.value;
                setQuestionsEmissions1(v);
                setStoredValue('questions_emissions_1', v);

                if (v !== "Sí" && v !== "En proceso") {
                  setQuestionsEmissions2("");
                  setStoredValue('questions_emissions_2', "");
                }
              }}
              required
            >
              <option value="" disabled>Seleccioná una opción</option>
              <option value="Sí">Sí</option>
              <option value="En proceso">En proceso</option>
              <option value="No">No</option>
              <option value="No lo sé">No lo sé</option>
            </select>
            {formErrors.questionsEmissions1 && <span className="required">{formErrors.questionsEmissions1}</span>}
          </div>

          <div className='col-2'>
            <label>¿Qué alcance de emisiones están considerando en su gestión? <b>*</b></label>
            <select
              value={questionsEmissions2}
              name='questions_emissions_2'
              onChange={(e) => {
                setQuestionsEmissions2(e.target.value);
                setStoredValue('questions_emissions_2', e.target.value);
              }}
              disabled={!requiresScope}               
              required={requiresScope}                
            >
              <option value="" disabled>Seleccioná una opción</option>
              <option value="Alcance 1">Sólo directas – Alcance 1</option>
              <option value="Alcance 1 y 2">Directas e indirectas – Alcance 1 y 2</option>
              <option value="Alcances 1, 2 y 3">Alcances 1, 2 y 3</option>
              <option value="No lo sé">No lo sé</option>
            </select>
            {formErrors.questionsEmissions2 && <span className="required">{formErrors.questionsEmissions2}</span>}
          </div>
        </div>

        <div className='containerFlex'>
          <div className='col-2'>
            <label>¿Cuál es hoy su mayor desafío para gestionar emisiones? <b>*</b></label>
            <select
              value={questionsEmissions3}
              name='questions_emissions_3'
              onChange={(e) => {
                setQuestionsEmissions3(e.target.value);
                setStoredValue('questions_emissions_3', e.target.value);
              }}
              required
            >
              <option value="" disabled>Seleccioná una opción</option>
              <option value="Falta de tiempo e inversión">Falta de tiempo e inversión</option>
              <option value="Falta de herramientas">Falta de herramientas</option>
              <option value="No está en la agenda">No está en la agenda</option>
              <option value="No lo sé">No lo sé</option>
            </select>
            {formErrors.questionsEmissions3 && <span className="required">{formErrors.questionsEmissions3}</span>}
          </div>
        </div>

        <div>
          <p className='legal'>*Los campos son requeridos</p>
        </div>

        <div className='containerFlex'>
          <div className='card flexBetween'>
            <div>
              <p className='legal'>Al enviar este formulario, aceptás nuestra <Link to='/privacy' target='blank'>Política de Privacidad.</Link></p>
            </div>

            <div className="flex" style={{ alignItems: 'center', gap: 12 }}>
              <button type="button" onClick={btnBack}>Volver</button>

              {submitError && (
                <p className="required" style={{ margin: 0 }}>
                  {submitError}
                </p>
              )}

              <button type="submit" disabled={submitting} aria-busy={submitting}>
                {submitting ? "Enviando..." : "Siguiente"}
              </button>
            </div>
          </div>

        </div>

        <h4 className="footerCopyright">Design, code, words, and hard work by <Link to="https://wcm.media" target="blank">Wildcat Media.</Link></h4>
      </form>
    </div>
  );
}
//check
export default App;